import { COMMENT_NEW, COMMENT_OPEN } from '@BUP/constants'
import { getApi } from '@BUP/services/Axios'
import { message } from 'antd'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

export const useChangeMessageState = () => {
  const [t] = useTranslation('translation', {
    keyPrefix: 'pages.modeBup.messageState'
  })

  const [data, setData] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(null)

  const handleChangeMessageState = async (messageId, value, newState) => {
    setIsLoading(true)
    setError(null)

    const moveTo =
      newState === COMMENT_NEW || newState === COMMENT_OPEN
        ? t('text1')
        : t('text2')

    try {
      const client = await getApi('schools', { version: 3 })
      const response = await client.patch(`/bup-modes/${messageId}`, {
        state: newState,
        anonymus: value
      })

      setData(response.data)
      message.success(`${t('messageSuccess')} ${moveTo}.`, 2)
    } catch (error) {
      console.error(error)
      setError(error)
      message.error(t('errorMessage'), 5)
    }
  }

  return { data, isLoading, error, handleChangeMessageState }
}
